import { render, staticRenderFns } from "./TrackAndTraceColumns.vue?vue&type=template&id=385a165e&scoped=true&"
import script from "./TrackAndTraceColumns.vue?vue&type=script&lang=js&"
export * from "./TrackAndTraceColumns.vue?vue&type=script&lang=js&"
import style0 from "./TrackAndTraceColumns.vue?vue&type=style&index=0&id=385a165e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385a165e",
  null
  
)

export default component.exports